import React from 'react';
import { bool, shape, string } from 'prop-types';

const FilterColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.2505 4.5H12.7505L8.993 9.225L5.2505 4.5ZM3.188 4.2075C4.703 6.15 7.5005 9.75 7.5005 9.75V14.25C7.5005 14.6625 7.838 15 8.2505 15H9.7505C10.163 15 10.5005 14.6625 10.5005 14.25V9.75C10.5005 9.75 13.2905 6.15 14.8055 4.2075C15.188 3.7125 14.8355 3 14.213 3H3.7805C3.158 3 2.8055 3.7125 3.188 4.2075Z" fill="currentColor" />
  </svg>
);

FilterColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default FilterColor;
